/**
 * BeneficiaryDetails
 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import { Field, FormSection } from 'redux-form/immutable';

import { Grid, Typography, FormControlLabel } from '@material-ui/core';
import messages from 'containers/ApplicationFormPage/messages';
import FormTextField from 'components/FormTextField';
import FormNumberField from 'components/FormNumberField';
import FormSelect from 'components/FormSelect';
import FormSwitch from 'components/FormSwitch';
import FormAutocomplete from 'components/FormAutocomplete';
import { productCodeCheck } from 'helpers/constants';

export function useISOcountrycode() {
  return sessionStorage.getItem('agentDetails');
}

const useStyle = makeStyles(theme => ({
  container: {
    marginTop: '1rem',
  },
  button: {
    fontWeight: 800,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  buttonContainer: {
    display: 'flex',
    alignContent: 'center',
    // alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100%',
  },
  hr: {
    margin: '0 0rem',
    borderTop: '1px solid #DDDFE0',
  },
  bold: {
    fontWeight: 800,
  },
}));

function PayorPolicy(props) {
  const intl = useIntl();
  const classes = useStyle();
  //Armed Service - Changes starts
  const {
    formValues,
    options,
    change,
    employerAddress,
    natureOfCompanyBusiness,
    agentDetails,
    applicationDetails,
    oowDetails,
  } = props;
  const ISOCode = useISOcountrycode()
  //Armed Service - Changes ends
  const [preLoadPayorPolicy, setPreLoadPayorPolicy] = useState(false);

   useEffect(() => {
      if (preLoadPayorPolicy) return;
      if (applicationDetails.isInforce) {
          if (applicationDetails.payorDetails && (applicationDetails.payorDetails.natureOfCompanyBusiness || applicationDetails.payorDetails.countryOOW) ) {
              change(`policyPaidBySalary.natureOfCompanyBusiness`, applicationDetails.payorDetails.natureOfCompanyBusiness);
              change(`policyPaidBySalary.countryOOW`, applicationDetails.payorDetails.countryOOW);
              return;
          } 
          if (oowDetails) {
            oowDetails.currentCategory.forEach(item => {
            const code = item.categoryCode;
            const nobCode = item.natureOfBusinessCode;
            const cateCountry = item.country;
            if (code === "INCOM") {
              change(`policyPaidBySalary.natureOfCompanyBusiness`, nobCode);
              change(`policyPaidBySalary.countryOOW`, cateCountry);
            } 
          
          });
          }
        }
      }, [oowDetails, change, applicationDetails]);


  function handleOOWChange(e) {
    change(`policyPaidBySalary.countryOOW`, e.target.value);
    setPreLoadPayorPolicy(true);
  } 

  function handleNOBChange(event, value) {
    change(`policyPaidBySalary.natureOfCompanyBusiness`, value);
    setPreLoadPayorPolicy(true);
  } 

  return (
    <Grid container spacing={3} className={classes.container}>
      <Grid item xs={8}>
        <Field
          name="employerName"
          component={FormTextField}
          label={<FormattedMessage {...messages.employerName} />}
          shrink
          fullWidth
          placeholder={intl.formatMessage(messages.pleaseEnter)}
        />
      </Grid>
      {/* Armed Service - Changes starts */}
      {['AE'].includes(ISOCode) &&

        <Grid item xs={8} container
          direction="row"
          alignItems="center"
          justify="space-between"
        >
          <Typography
            variant="body1"
            style={{
              marginRight: '0px',
              fontSize: '14px',
              fontWeight: 600
            }}>
            <FormattedMessage {...messages.armyservice} />
          </Typography>
          <Field name="armyservice"
            component={FormSwitch}
            onChange={(e, newval) => {
              const data = newval;
              if (data) {
                change('policyPaidBySalary.employerAddress', "N.A");
                change('policyPaidBySalary.natureOfCompanyBusiness', "N.A");
                change('policyPaidBySalary.jobTitle', "NA");
              }
              else {
                change('policyPaidBySalary.employerAddress', "");
                change('policyPaidBySalary.natureOfCompanyBusiness', "");
                change('policyPaidBySalary.jobTitle', "");
              }
            }
            }
          />
        </Grid>
      }
      {/* Armed Service - Changes ends */}
      <Grid item xs={8}>
        <Field
          name="jobTitle"
          component={FormTextField}
          label={<FormattedMessage {...messages.nameOfJobTitle} />}
          shrink
          fullWidth
          placeholder={intl.formatMessage(messages.pleaseEnter)}
          disabled={props.formValues.policyPaidBySalary ? props.formValues.policyPaidBySalary.armyservice : false}
        />
      </Grid>
      <Grid item xs={8}>
        <Field
          name="employerAddress"
          component={FormTextField}
          label={<FormattedMessage {...messages.employerAddress} />}
          multiline
          rows={3}
          shrink
          fullWidth
          placeholder={intl.formatMessage(messages.pleaseProvideDetails)}
          type="text"  
          disabled={props.formValues.policyPaidBySalary? props.formValues.policyPaidBySalary.armyservice : false}
        />
      </Grid>
      {/* {!applicationDetails.isInforce && ( */}
      <Grid item xs={8}>
        <Field
          name="countryOOW"
          component={FormSelect}
          label={<FormattedMessage {...messages.countryOOW} />}
          options={[
            { value: 'Select', title: 'Select an option' },
            ...options.countryCode,
          ]}
          onChange={handleOOWChange}
          shrink
          fullWidth
        />
      </Grid>
      {/* )} */}
      {/* {!applicationDetails.isInforce ? ( */}
      <Grid item xs={8}>
        <Field
          name="natureOfCompanyBusiness"
          component={FormAutocomplete}
          label={<FormattedMessage {...messages.natureOfCompanyBusiness} />}
          options={[
            { value: 'Select', title: 'Select an option' },
            ...options.natureOfBusiness,
          ]}
          onChange={handleNOBChange}
          shrink
          fullWidth
          disabled={
            props.formValues.policyPaidBySalary
              ? props.formValues.policyPaidBySalary.armyservice
              : false
          }
        />
      </Grid>
      {/* // ) : (
      //   <Grid item xs={8}>
      //     <Field
      //       name="natureOfCompanyBusiness"
      //       component={FormTextField}
      //       label={<FormattedMessage {...messages.natureOfCompanyBusiness} />}
      //       shrink
      //       fullWidth
      //       disabled={
      //         props.formValues.policyPaidBySalary
      //           ? props.formValues.policyPaidBySalary.armyservice
      //           : false
      //       }
      //     />
      //   </Grid>
      // )} */}
      <Grid item xs={4}></Grid>
      <Grid item xs={3}>
        <Field
          name="countryDialingCode"
          component={FormSelect}
          label={<FormattedMessage {...messages.countryCode} />}
          options={[
            { value: 'Select', title: 'Select an option' },
            ...options.countryDialingCode,
          ]}
          shrink
          fullWidth
        />
      </Grid>
      <Grid item xs={5}>
        <Field
          name="phoneNumber"
          component={FormNumberField}
          label={<FormattedMessage {...messages.employerPhone} />}
          shrink
          fullWidth
          thousandSeparator=""
          placeholder={intl.formatMessage(messages.pleaseEnter)}
        />
      </Grid>
      <Grid item xs={8}>
        <Field
          name="annualIncome"
          component={FormNumberField}
          label={<FormattedMessage {...messages.bonusAmount} />}
          shrink
          fullWidth
          placeholder={intl.formatMessage(messages.pleaseEnter)}
        />
      </Grid>
      <Grid
        item
        xs={12}
        style={{ padding: '12px 12px 0 12px', marginBottom: '-5px' }}
      >
        <Typography variant="body2" className={classes.bold}>
          <FormattedMessage {...messages.durationOfEmployment} />
        </Typography>
      </Grid>
      <Grid item xs={5}>
        <Field
          name="durationOfEmployment"
          component={FormNumberField}
          shrink
          fullWidth
        />
      </Grid>

      <Grid item xs={8}>
        <Field
          name="durationOfSavings"
          component={FormNumberField}
          label={<FormattedMessage {...messages.durationOfsavingsLabel} />}
          shrink
          fullWidth
          thousandSeparator=""
          placeholder={intl.formatMessage(messages.pleaseEnter)}
        />
      </Grid>
    </Grid>
  );
}

PayorPolicy.propTypes = {
  options: PropTypes.object,
  productCode: PropTypes.string,
  change: PropTypes.func,
  applicationDetails: PropTypes.object,
  oowDetails: PropTypes.object,
};

export default PayorPolicy;
